/**
 * Helper functions for extracting data from JotForm submissions
 */

export const extractNameFromAnswers = (answers: Record<string, any> | undefined): string => {
  if (!answers) return 'N/A';

  let fullName = '';
  let firstName = '';
  let lastName = '';

  Object.values(answers).forEach((answer: any) => {
    const fieldName = answer?.name?.toLowerCase() || '';
    const fieldText = answer?.text?.toLowerCase() || '';

    // Buscar nombre completo primero (tiene prioridad)
    if (fieldText.includes('nombre completo') ||
        fieldText.includes('nombre y apellidos') ||
        fieldName.includes('nombrecompleto') ||
        fieldName.includes('nombreyapellidos')) {
      const value = answer.answer || answer.prettyFormat || '';
      // Si el valor es un objeto con first/last
      if (typeof value === 'object' && value !== null) {
        if (value.first || value.last) {
          fullName = [value.first, value.middle, value.last].filter(Boolean).join(' ');
        }
      } else if (typeof value === 'string' && value.trim()) {
        fullName = value.trim();
      }
    }

    // Buscar nombre y apellido por separado (solo si no hay fullName)
    if (!fullName) {
      if (fieldName === 'nombre' || fieldName === 'referido-nombre' ||
          fieldText.includes('nombre') && !fieldText.includes('apellido')) {
        const value = answer.answer || answer.text || '';
        if (typeof value === 'object' && value?.first) {
          firstName = value.first;
        } else if (typeof value === 'string') {
          firstName = value;
        }
      }

      if (fieldName === 'apellido' || fieldName === 'apellidos' ||
          fieldName === 'referido-apellido2' || fieldText.includes('apellido')) {
        const value = answer.answer || answer.text || '';
        if (typeof value === 'object' && value?.last) {
          lastName = value.last;
        } else if (typeof value === 'string') {
          lastName = value;
        }
      }
    }
  });

  // Retornar en orden de prioridad
  if (fullName) return fullName;
  if (firstName && lastName) return `${firstName} ${lastName}`;
  if (firstName) return firstName;
  if (lastName) return lastName;
  return 'N/A';
};

/**
 * Extrae el email de las respuestas de un submission de JotForm
 */
export const extractEmailFromAnswers = (answers: Record<string, any> | undefined): string => {
  if (!answers) return 'N/A';

  const emailAnswer = Object.values(answers).find((answer: any) => {
    const name = answer?.name?.toLowerCase() || '';
    const text = answer?.text?.toLowerCase() || '';
    return name === 'email' || name === 'correo' || name === 'referido-email' ||
           name.includes('correoelectronico') || name.includes('correo-electronico') ||
           text.includes('correo electrónico') || text.includes('email');
  });

  return (emailAnswer as any)?.answer || 'N/A';
};

/**
 * Wrapper para extraer nombre de un objeto submission completo
 * Soporta tanto 'answers' como 'raw_answers'
 */
export const getSubmissionName = (submission: { answers?: Record<string, any>; raw_answers?: Record<string, any> }): string => {
  const answers = submission?.answers || submission?.raw_answers;
  return extractNameFromAnswers(answers);
};

/**
 * Wrapper para extraer email de un objeto submission completo
 * Soporta tanto 'answers' como 'raw_answers'
 */
export const getSubmissionEmail = (submission: { answers?: Record<string, any>; raw_answers?: Record<string, any> }): string => {
  const answers = submission?.answers || submission?.raw_answers;
  return extractEmailFromAnswers(answers);
};
